export default __webpack_public_path__ + "static/media/puffer-fish2.99b27eb4.png";